import { useAnalyticsTracking, useEmitUiEvent } from '@montugroup/data-collection';
import { useCallback } from 'react';

export const useClinicTelecomTracking = () => {
  const emitEvent = useEmitUiEvent();
  const { uiEvent } = useAnalyticsTracking();
  const contextId = uiEvent?.context_id;

  // NOTE:
  // trackStartConsultation is NOT wrapped by the analytics/consultation context.
  // So the consultation context will NOT auto-populate `consultation_id` like it does elsewhere.
  // We therefore attach the consultation context manually here.
  const trackStartConsultation = useCallback(
    (consultationId: number) => {
      emitEvent(
        {
          component_name: 'StartConsultationButton',
          event_name: 'start_consultation_button_click',
          id: 'start_consultation_btn',
          context_id: contextId,
        },
        consultationId ? { consultation: { consultation_id: String(consultationId) } } : {},
      );
    },
    [emitEvent, contextId],
  );

  return {
    trackStartConsultation,
  };
};
